var k = Object.defineProperty;
var R = (r, e, t) => e in r ? k(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var l = (r, e, t) => R(r, typeof e != "symbol" ? e + "" : e, t);
import { E as B } from "./platform-components-assets/index-es2.js";
import f from "./DomHelper.js";
import { i as p, b as A, r as M, f as P } from "./platform-components-assets/isObject-es.js";
import { i as $, a as E } from "./platform-components-assets/isFunction-es.js";
import { i as D, a as H } from "./platform-components-assets/_isIndex-es.js";
var q = 9007199254740991;
function v(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= q;
}
function j(r) {
  return r != null && v(r.length) && !$(r);
}
var U = Object.prototype;
function L(r) {
  var e = r && r.constructor, t = typeof e == "function" && e.prototype || U;
  return r === t;
}
function G(r, e) {
  for (var t = -1, n = Array(r); ++t < r; )
    n[t] = e(t);
  return n;
}
var K = "[object Arguments]";
function b(r) {
  return p(r) && A(r) == K;
}
var I = Object.prototype, V = I.hasOwnProperty, W = I.propertyIsEnumerable, X = b(/* @__PURE__ */ function() {
  return arguments;
}()) ? b : function(r) {
  return p(r) && V.call(r, "callee") && !W.call(r, "callee");
};
function z() {
  return !1;
}
var C = typeof exports == "object" && exports && !exports.nodeType && exports, x = C && typeof module == "object" && module && !module.nodeType && module, J = x && x.exports === C, _ = J ? M.Buffer : void 0, Q = _ ? _.isBuffer : void 0, Y = Q || z, Z = "[object Arguments]", ee = "[object Array]", te = "[object Boolean]", re = "[object Date]", ne = "[object Error]", se = "[object Function]", oe = "[object Map]", ae = "[object Number]", de = "[object Object]", ie = "[object RegExp]", fe = "[object Set]", ce = "[object String]", le = "[object WeakMap]", ue = "[object ArrayBuffer]", he = "[object DataView]", me = "[object Float32Array]", ge = "[object Float64Array]", Ne = "[object Int8Array]", Oe = "[object Int16Array]", pe = "[object Int32Array]", be = "[object Uint8Array]", xe = "[object Uint8ClampedArray]", _e = "[object Uint16Array]", Se = "[object Uint32Array]", s = {};
s[me] = s[ge] = s[Ne] = s[Oe] = s[pe] = s[be] = s[xe] = s[_e] = s[Se] = !0;
s[Z] = s[ee] = s[ue] = s[te] = s[he] = s[re] = s[ne] = s[se] = s[oe] = s[ae] = s[de] = s[ie] = s[fe] = s[ce] = s[le] = !1;
function ye(r) {
  return p(r) && v(r.length) && !!s[A(r)];
}
function Te(r) {
  return function(e) {
    return r(e);
  };
}
var F = typeof exports == "object" && exports && !exports.nodeType && exports, m = F && typeof module == "object" && module && !module.nodeType && module, Ae = m && m.exports === F, O = Ae && P.process, S = function() {
  try {
    var r = m && m.require && m.require("util").types;
    return r || O && O.binding && O.binding("util");
  } catch {
  }
}(), y = S && S.isTypedArray, Ee = y ? Te(y) : ye, ve = Object.prototype, je = ve.hasOwnProperty;
function Ie(r, e) {
  var t = E(r), n = !t && X(r), o = !t && !n && Y(r), d = !t && !n && !o && Ee(r), i = t || n || o || d, c = i ? G(r.length, String) : [], h = c.length;
  for (var a in r)
    je.call(r, a) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (a == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (a == "offset" || a == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    d && (a == "buffer" || a == "byteLength" || a == "byteOffset") || // Skip index properties.
    D(a, h))) && c.push(a);
  return c;
}
function Ce(r, e) {
  return function(t) {
    return r(e(t));
  };
}
var Fe = Ce(Object.keys, Object), we = Object.prototype, ke = we.hasOwnProperty;
function Re(r) {
  if (!L(r))
    return Fe(r);
  var e = [];
  for (var t in Object(r))
    ke.call(r, t) && t != "constructor" && e.push(t);
  return e;
}
function Be(r) {
  return j(r) ? Ie(r) : Re(r);
}
function Me(r) {
  return function(e, t, n) {
    for (var o = Object(e), d = n(e), i = d.length; i--; ) {
      var c = d[i];
      if (t(o[c], c, o) === !1)
        break;
    }
    return e;
  };
}
function Pe(r, e) {
  return function(t, n) {
    if (t == null)
      return t;
    if (!j(t))
      return r(t, n);
    for (var o = t.length, d = o, i = Object(t); d-- && n(i[d], d, i) !== !1; )
      ;
    return t;
  };
}
function $e(r) {
  return typeof r == "function" ? r : H;
}
function De(r, e) {
  for (var t = r == null ? 0 : r.length; t-- && e(r[t], t, r) !== !1; )
    ;
  return r;
}
var He = Me();
function qe(r, e) {
  return r && He(r, e, Be);
}
var Ue = Pe(qe);
function Le(r, e) {
  var t = E(r) ? De : Ue;
  return t(r, $e(e));
}
const u = class u {
  /**
   * @param {Object} options The options to be used by the Selection instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   *
   * @example
   * const contextEl = document.querySelector('main');
   *
   * const selection = new Selection({
   *   contextContainer: contextEl,
   *   ignoredElements: [
   *     'span',
   *     '.nebula-button',
   *   ],
   * });
   *
   * // update from data
   * selection.updateFromData(...);
   *
   * // or, listen to events
   * selection.on('select', ...);
   */
  constructor(e) {
    l(this, "_clientId");
    l(this, "_commonAncestor");
    l(this, "_domHelper");
    l(this, "_endNode");
    l(this, "_endNodeSelector");
    l(this, "_endOffset");
    l(this, "_eventBus");
    l(this, "_isStale");
    l(this, "_startNode");
    l(this, "_startNodeSelector");
    l(this, "_startOffset");
    l(this, "_text");
    this._clientId = u.getNextClientId(), this._domHelper = new f({
      contextContainer: e == null ? void 0 : e.contextContainer,
      ignoredElements: e == null ? void 0 : e.ignoredElements,
      nodeSelectors: e == null ? void 0 : e.nodeSelectors
    }), this._eventBus = new B(), this.clearData(), this.setStale();
  }
  /**
   * The unique client ID of this instance.
   * @type {Number}
   * @readonly
   *
   * @example
   * const selection = new Selection();
   *
   * // prints the client-id
   * console.log(selection.clientId);
   *
   * // throws an exception
   * selection.clientId = 123;
   */
  get clientId() {
    return this._clientId;
  }
  /**
   * The common ancestor element to the start and end nodes of the instance.
   * @type {Node.ELEMENT_NODE}
   * @readonly
   */
  get commonAncestor() {
    return this._commonAncestor ? this._commonAncestor : (this._commonAncestor = f.getCommonAncestor(
      this.startNode,
      this.endNode
    ), this._commonAncestor);
  }
  /**
   * The context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   */
  get contextContainer() {
    return this.domHelper.contextContainer;
  }
  set contextContainer(e) {
    this.domHelper.contextContainer = e;
  }
  /**
   * The immediate parent of context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   * @readonly
   */
  get contextContainerParent() {
    var e;
    return ((e = this.contextContainer) == null ? void 0 : e.parentNode) || null;
  }
  /**
   * The {@link DomHelper} instance used by this selection.
   * @type {DomHelper}
   * @readonly
   */
  get domHelper() {
    return this._domHelper;
  }
  /**
   * The end node of the selection.
   * @type {Node}
   */
  get endNode() {
    return this.endNode = this._getActiveDomNode(
      this._endNode,
      this.endNodeSelector,
      this.endOffset
    ), this._endNode;
  }
  set endNode(e) {
    e !== this._endNode && (this._commonAncestor = null, this._endNode = e);
  }
  /**
   * The context element for the end node.
   * @readonly
   */
  get endNodeContextElement() {
    return document.querySelector(this.endNodeSelector) || null;
  }
  /**
   * The CSS selector for the end node.
   * @readonly
   */
  get endNodeSelector() {
    return this._endNodeSelector;
  }
  /**
   * The offset for the end node.
   * @readonly
   */
  get endOffset() {
    return this._endOffset;
  }
  /**
   * The event bus for this instance.
   * @type {EventBus}
   * @readonly
   */
  get eventBus() {
    return this._eventBus;
  }
  /**
   * The array of ignored element selectors.
   * @type {String[]}
   */
  get ignoredElements() {
    return this.domHelper.ignoredElements;
  }
  set ignoredElements(e) {
    this.domHelper.ignoredElements = e;
  }
  /**
   * A flag indicating whether this selection is stale.
   * This flag is NOT set automatically and relies on
   * other parts of the code setting and using it
   * appropriately.
   * @type {Boolean}
   * @readonly
   */
  get isStale() {
    return this._isStale;
  }
  /**
   * The node selectors data object.
   * @type {NodeSelectorsData}
   */
  get nodeSelectors() {
    return this.domHelper.nodeSelectors;
  }
  set nodeSelectors(e) {
    this.domHelper.nodeSelectors = e;
  }
  /**
   * The start node of the selection.
   * @type {Node}
   */
  get startNode() {
    return this.startNode = this._getActiveDomNode(
      this._startNode,
      this.startNodeSelector,
      this.startOffset
    ), this._startNode;
  }
  set startNode(e) {
    e !== this._startNode && (this._commonAncestor = null, this._startNode = e);
  }
  /**
   * The context element for the start node.
   * @readonly
   */
  get startNodeContextElement() {
    return document.querySelector(this.startNodeSelector) || null;
  }
  /**
   * The CSS selector for the start node.
   * @readonly
   */
  get startNodeSelector() {
    return this._startNodeSelector;
  }
  /**
   * The offset for the start node.
   * @readonly
   */
  get startOffset() {
    return this._startOffset;
  }
  /**
   * The text of the given selection.
   * @type {?String}
   * @readonly
   */
  get text() {
    return this._text;
  }
  /**
   * Clear any selection data.
   */
  clearData() {
    this._commonAncestor = null, this._endNode = null, this._endOffset = null, this._endNodeSelector = null, this._startNode = null, this._startOffset = null, this._startNodeSelector = null, this._text = null, this.setFresh();
  }
  /**
   * Dispatch an event on the event-bus.
   * @private
   * @param {String} eventName The name of the event to dispatch.
   * @param {Any} data The data to pass along into the event data.
   */
  _dispatchEvent(e, t) {
    this.eventBus.emit(
      e,
      {
        context: this,
        data: t
      }
    );
  }
  /**
   * Get the active text-node from the DOM. Used to get around stale selections in the DOM after DOM manipulation actions.
   * @private
   * @param {Node} textNode The text-node to check and return the active node for.
   * @param {String} elementSelector The selector of the parent element containing the text-node
   * @param {Number} trueOffset The true offset of the node in the DOM with respect to it's parent element.
   * @returns {Node} Returns the active text node.
   */
  _getActiveDomNode(e, t, n) {
    if (!e)
      return null;
    if (f.isNodeInDom(e))
      return e;
    this._commonAncestor = null;
    const o = document.querySelector(t);
    return f.getTextNodeFromOffset(
      o,
      n
    ).targetNode;
  }
  /**
   * Returns a {@link SelectionData} object with all the relevant selection data that can then be used to save to and update from a data-store.
   * @returns {SelectionData} Returns an object with all the relevant selection data.
   */
  getData() {
    return {
      commonAncestor: this.commonAncestor,
      endNode: this.endNode,
      endNodeSelector: this.endNodeSelector,
      endOffset: this.endOffset,
      startNode: this.startNode,
      startNodeSelector: this.startNodeSelector,
      startOffset: this.startOffset,
      text: this.text
    };
  }
  /**
   * Get an array of the marked elements. If the optional `markerId` is provided,
   * it will only return the elements corresponding to that id.
   * @param {Number} [markerId] Optional numeric marker id.
   * @returns {Array} An array of the marked elements.
   */
  getMarkedElements(e = null) {
    let t = `.de-selection-marker[data-client-id="${this.clientId}"]`;
    return e && (t = `${t}[data-marker-id="${e}"]`), [
      ...document.querySelectorAll(t)
    ];
  }
  /**
   * Marks the selection with elements in the DOM. Can be used to target with
   * other software like TTS or highlighting.
   * @param {String} element The element that will wrap the selection. Defaults to `<mark>` but can be overwritten
   */
  mark(e = "mark") {
    if (!this.startNode || !this.endNode)
      return [];
    this.unmark();
    let t = null;
    if (this.startNode === this.endNode)
      t = [
        this.startNode
      ];
    else {
      const i = f.getIntermediateTextNodes(
        this.startNode,
        this.endNode
      );
      t = [
        this.startNode,
        ...i,
        this.endNode
      ];
    }
    const n = u.getNextMarkerId(), o = `de-selection_client-${this.clientId}_marker-${n}_`, d = t.length - 1;
    return Le(t, (i, c) => {
      const h = `${o}index-${c}`, a = document.createElement(e);
      a.classList.add(
        "de-selection-marker"
      ), a.setAttribute("id", h), a.setAttribute(
        "data-client-id",
        this.clientId
      ), a.setAttribute(
        "data-marker-id",
        n
      ), a.setAttribute(
        "data-index",
        c
      );
      let g = null, N = null;
      c === 0 && (g = f.getTextNodeFromOffset(
        this.startNodeContextElement,
        this.startOffset,
        !0
      ).relativeOffset), c === d && (N = f.getTextNodeFromOffset(
        this.endNodeContextElement,
        this.endOffset,
        !1
      ).relativeOffset), f.injectElementInNode(
        i,
        a,
        g,
        N
      );
    }), this.getMarkedElements(n);
  }
  /**
   * Selects the text in the DOM.
   */
  select() {
    if (!this.startNode || !this.endNode)
      return;
    const e = u.getSelectionRange({
      startNodeSelector: this.startNodeSelector,
      startOffset: this.startOffset,
      endNodeSelector: this.endNodeSelector,
      endOffset: this.endOffset
    });
    if (!e)
      return;
    const t = document.getSelection();
    t.empty(), t.addRange(e), this._dispatchEvent("select", this);
  }
  /**
   * Sets the current selection as fresh (not stale).
   */
  setFresh() {
    this._isStale = !1;
  }
  /**
   * Sets the current selection as stale.
   */
  setStale() {
    this._isStale = !0;
  }
  /**
   * Unmarks the current markers from the DOM. If a `markerId` is
   * provided only elements corresponding to that id are unmarked.
   * @param {Number} [markerId] Optional numeric marker id.
  */
  unmark(e = null) {
    this.getMarkedElements(e).forEach((n) => {
      const o = n.innerHTML;
      f.replaceNodeWithContent(n, o);
    });
  }
  /**
   * Update the selection using data instead of DOM Ranges. Will implicityly mark the selection as fresh.
   * @param {Object} selectionData An object that contains data pertaining to the selection.
   * @returns {Boolean} Returns `true` if successful, `false` otherwise.
   */
  updateFromData(e) {
    const t = u.getSelectionRange({
      startNodeSelector: e.startNodeSelector,
      startOffset: e.startOffset,
      endNodeSelector: e.endNodeSelector,
      endOffset: e.endOffset
    });
    return t ? (this.updateFromRange(t), !0) : !1;
  }
  /**
   * Updates the current selection using the given Range instance.
   * @param {Range} range The Range instance to use to update the selection.
   */
  updateFromRange(e) {
    const t = {
      endNode: e.endContainer,
      endOffset: e.endOffset,
      startNode: e.startContainer,
      startOffset: e.startOffset
    };
    this._text = e.toString() || null;
    const n = f.compareNodePosition(
      t.startNode,
      t.endNode
    ).isPreceding;
    if (t.startNode === t.endNode && t.startOffset > t.endOffset) {
      const h = t.endOffset, a = t.startOffset;
      t.startOffset = h, t.endOffset = a;
    } else if (n) {
      const h = t.endNode, a = t.endOffset, g = t.startNode, N = t.startOffset;
      t.startNode = h, t.startOffset = a, t.endNode = g, t.endOffset = N;
    }
    this._commonAncestor = null;
    const o = f.getTextNodeFromOffset(
      t.endNode,
      t.endOffset,
      !1
    ), d = o.targetNode;
    this.endNode = d, this._endNodeSelector = this.domHelper.getNodeSelector(
      d
    ), this._endOffset = f.getOffsetForTextNode(
      d,
      this.endNodeContextElement,
      o.relativeOffset
    );
    const i = f.getTextNodeFromOffset(
      t.startNode,
      t.startOffset,
      !0
    ), c = i.targetNode;
    this.startNode = c, this._startNodeSelector = this.domHelper.getNodeSelector(
      c
    ), this._startOffset = f.getOffsetForTextNode(
      c,
      this.startNodeContextElement,
      i.relativeOffset
    ), this.setFresh();
  }
  /**
   * Returns a unique numeric client-id for the current window and increments the _nextClientId counter by 1.
   * @returns {Number} A unique numeric client-id for the current window.
   */
  static getNextClientId() {
    const e = this._nextClientId;
    return this._nextClientId += 1, e;
  }
  /**
   * Returns a unique numeric marker-id for the current window and increments the _nextMarkerId counter by 1.
   * @returns {Number} A unique numeric marker-id for the current window.
   */
  static getNextMarkerId() {
    const e = this._nextMarkerId;
    return this._nextMarkerId += 1, e;
  }
  /**
   * Returns the selection range from the given selection data.
   * @param {SelectionData} selectionData The selection data to use for defining the range.
   * @returns {?Range} The selection Range instance or `null` if the data is invalid.
   */
  static getSelectionRange(e) {
    const t = new Range(), n = document.querySelector(
      e.startNodeSelector
    ), o = document.querySelector(
      e.endNodeSelector
    );
    if (!n || !o)
      return null;
    const d = f.getTextNodeFromOffset(
      n,
      e.startOffset,
      !0
    );
    t.setStart(
      d.targetNode,
      d.relativeOffset
    );
    const i = f.getTextNodeFromOffset(
      o,
      e.endOffset,
      !1
    );
    return t.setEnd(
      i.targetNode,
      i.relativeOffset
    ), t;
  }
};
// +===================================+
// | Static implementation starts here |
// +===================================+
l(u, "_nextClientId", 1), l(u, "_nextMarkerId", 1);
let T = u;
export {
  T as default
};
